import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiHexagon } = FiIcons;

const AuthLayout = ({ children, title, subtitle }) => {
    return (
        <div className="min-h-screen flex flex-col md:flex-row bg-white dark:bg-gray-900">
            {/* Left Side: Illustration & Brand */}
            <div className="hidden md:flex md:w-1/2 lg:w-3/5 bg-indigo-600 dark:bg-indigo-900 items-center justify-center p-12 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full opacity-10">
                    <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-white blur-[100px]" />
                    <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-white blur-[100px]" />
                </div>

                <div className="relative z-10 max-w-lg text-center">
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        className="inline-flex items-center justify-center mb-10 w-20 h-20 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20"
                    >
                        <SafeIcon icon={FiHexagon} className="text-white text-4xl" />
                    </motion.div>
                    <motion.h1
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}
                        className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
                    >
                        Streamline your IT service management
                    </motion.h1>
                    <motion.p
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.3 }}
                        className="text-indigo-100 text-lg"
                    >
                        Join thousands of IT professionals using ITSM Planner to manage incidents, automate workflows, and deliver exceptional service.
                    </motion.p>
                </div>

                {/* Floating cards animation placeholder */}
                <div className="absolute bottom-10 left-10 right-10 flex justify-center gap-4 opacity-40">
                    <div className="w-32 h-40 bg-white/10 rounded-xl backdrop-blur-sm" />
                    <div className="w-32 h-40 bg-white/10 rounded-xl backdrop-blur-sm mt-8" />
                    <div className="w-32 h-40 bg-white/10 rounded-xl backdrop-blur-sm" />
                </div>
            </div>

            {/* Right Side: Form */}
            <div className="flex-1 flex flex-col justify-center px-6 py-12 md:px-12 lg:px-20 relative">
                <div className="absolute top-8 left-8 md:hidden">
                    <Link to="/" className="flex items-center gap-2 text-indigo-600 dark:text-indigo-400 font-bold text-xl">
                        <SafeIcon icon={FiHexagon} />
                        <span>ITSM Planner</span>
                    </Link>
                </div>

                <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    className="w-full max-w-md mx-auto"
                >
                    <div className="text-center md:text-left mb-8">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{title}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{subtitle}</p>
                    </div>
                    {children}
                </motion.div>
            </div>
        </div>
    );
};

export default AuthLayout;